<template>
  <div id="applySuccess">
    <header-nav :content="`${key === 'outbound' ? $t('pages_router_036') : $t('pages_router_021')} / ${$t('pages_pay_063')}`" />
    <div class="common-card-body">
      <a-steps :current="2" size="small" class="apply-step">
        <a-step :title="$t('pages_pay_014')" />
        <a-step :title="$t('pages_pay_015')" />
        <a-step :title="$t('pages_pay_016')" />
      </a-steps>
      <div class="apply-result">
        <div class="title flex-align">
          <check-circle-outlined class="ic-success" />
          <span>{{ $t('pages_pay_064') }}</span>
        </div>
        <div class="desc">
          <span>{{ $t('pages_pay_065') }}</span>
          <span
            class="link-line"
            @click="$router.replace({ path: '/funds/review', query: { key: key }})"
          >{{ $t('pages_pay_066') }}</span>
          <span>{{ $t('pages_pay_067') }}</span>
        </div>
        <div class="edit">
          <a-button
            shape="round"
            type="primary"
            class="success-btn"
            @click="$router.back(-1)"
          >{{ $t('pages_pay_068') }}</a-button>
          <a-button
            shape="round"
            style="margin-left: 18px"
            class="success-btn"
            type="primary"
            ghost
            @click="$router.replace({ path: '/funds/review', query: { key: key }})"
          >{{ $t('pages_pay_069') }}</a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import HeaderNav from '@/components/header-nav'
export default {
  name: 'ApplySuccess',
  components: {
    'header-nav': HeaderNav
  },
  setup () {
    const route = useRoute()
    const state = reactive({
      key: route.query.key || 'outbound'
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less">
#applySuccess {
  .common-card-body {
    padding: 18px 36px 64px 36px;
    .apply-result {
      margin-top: 60px;
      .title {
        justify-content: center;
        font-size: 24px;
        font-weight: 500;
        .ic-success {
          color: #02A900;
          margin-right: 8px;
          font-size: 28px;
        }
      }
      .desc {
        margin-top: 32px;
        .link-line {
          color: @main-color;
          padding: 0 2px;
          cursor: pointer;
        }
      }
      .edit {
        margin-top: 36px;
        .success-btn {
          min-width: 138px;
        }
      }
    }
  }
}
</style>
